import React from 'react'

import Select from 'react-select'
import CreateDtcMappingsCheckbox from './ConnectorMapping/ConnectorPinsSection/CreateDtcMappingsCheckbox'

const CloneMappings = ({ payload, setPayload, dtcsOptions }) => {
  return (
    <>
      <Select
        name="target_dtcs_ids[]"
        classNamePrefix="dtcs-filter"
        isMulti={true}
        options={dtcsOptions}
        placeholder="Select DTCs"
        className={`cursor-pointer py-2 pt-8 w-3/4`}
        onChange={(values) => {
          setPayload({ ...payload, target_dtcs: values })
        }}
        value={payload?.target_dtcs}
        isLoading={dtcsOptions?.length < 1}
      />
      {payload?.target_dtcs?.length > 0 && (
        <>
          <CreateDtcMappingsCheckbox
            title="Clone existing DTC Mappings"
            field="clone_with_existing_mapping"
            checked={payload?.clone_with_existing_mapping}
            onChange={(value) => {
              setPayload({ ...payload, clone_with_existing_mapping: value })
            }}
          />
          <CreateDtcMappingsCheckbox
            title="With Circuit Filters"
            field="create_dtc_circuits"
            checked={payload?.create_dtc_circuits}
            onChange={(value) => {
              setPayload({ ...payload, create_dtc_circuits: value })
            }}
          />
        </>
      )}
    </>
  )
}

CloneMappings.propTypes = {}

export default CloneMappings
